(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-home-moments"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fd-home-moments')){
  customElements.define('fd-home-moments',class extends HTMLElement{
    connectedCallback(){this.frame=requestAnimationFrame(()=>this.init())}
    init(){
      if(this.initialized)return;this.initialized=true;
      this.track=this.querySelector('[data-moments-track]');if(!this.track)return;
      this.items=Array.from(this.track.children);this.pauseButton=this.querySelector('[data-moments-pause]');this.pauseLabel=this.querySelector('[data-moments-pause-label]');this.counter=this.querySelector('[data-moments-count]');
      this.desktop=matchMedia('(min-width:750px)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.paused=false;this.hovered=false;this.focused=false;
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.querySelector('[data-moments-next]').addEventListener('click',()=>{this.move(1);this.start()},options);
      this.querySelector('[data-moments-prev]').addEventListener('click',()=>{this.move(-1);this.start()},options);
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.setAttribute('aria-label',this.paused?'Start autoplay':'Pause autoplay');this.pauseLabel.textContent=this.paused?'Play':'Pause';this.start()},options);
      this.addEventListener('pointerenter',()=>{this.hovered=true},options);this.addEventListener('pointerleave',()=>{this.hovered=false},options);
      this.addEventListener('focusin',()=>{this.focused=true},options);this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement)})},options);
      this.track.addEventListener('scroll',()=>this.update(),{passive:true,...options});document.addEventListener('visibilitychange',()=>this.start(),options);
      this.change=()=>this.start();this.desktop.addEventListener('change',this.change);this.reduced.addEventListener('change',this.change);
      this.start();this.update();
    }
    start(){clearInterval(this.timer);if(this.dataset.autoplay!=='true'||!this.desktop.matches||this.reduced.matches||this.paused||document.hidden||this.items.length<2)return;this.timer=setInterval(()=>{if(!this.hovered&&!this.focused)this.move(1)},Math.max(3000,Number(this.dataset.delay)||4500))}
    move(direction){const step=this.items.length>1?this.items[1].offsetLeft-this.items[0].offsetLeft:this.track.clientWidth;const maximum=Math.max(0,this.track.scrollWidth-this.track.clientWidth);let left=this.track.scrollLeft+direction*step;if(direction>0&&this.track.scrollLeft>=maximum-3)left=0;if(direction<0&&this.track.scrollLeft<=3)left=maximum;this.track.scrollTo({left:Math.max(0,Math.min(maximum,left)),behavior:this.reduced.matches?'auto':'smooth'})}
    update(){if(!this.items.length)return;const step=this.items.length>1?this.items[1].offsetLeft-this.items[0].offsetLeft:this.track.clientWidth;const index=step?Math.round(this.track.scrollLeft/step)+1:1;this.counter.textContent=index+' / '+this.items.length}
    disconnectedCallback(){cancelAnimationFrame(this.frame);clearInterval(this.timer);this.controller?.abort();if(this.change){this.desktop?.removeEventListener('change',this.change);this.reduced?.removeEventListener('change',this.change)}this.initialized=false}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
